import React, { useState, useEffect } from 'react';
import './CallBack.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCopy, faArrowLeft, faPrint } from '@fortawesome/free-solid-svg-icons';
import { BraintreeService, PaymentService } from '../../Services/Axios/Api';
import CTAPrimaryButton from '../../Components/CTAButton/CTAPrimaryButton/CTAPrimaryButton';
import CTASecondaryButton from '../../Components/CTAButton/CTASecondaryButton/CTASecondaryButton';
import { useTranslation } from 'react-i18next';

const CallBack = () => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { method } = useParams();
  console.log(method);
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  const payerId = searchParams.get('PayerID');
  const paymentId = searchParams.get('paymentId');



  useEffect(() => {
    const fetchPaymentDetails = async () => {
      try {
        var response = null;
        if(method.toLocaleLowerCase() === "paypal"){
            response = await PaymentService.GetPaymentDetailsPayPal(paymentId, payerId);
        }else if(method.toLocaleLowerCase() === "ahlymomken"){
          console.log(searchParams.get('id'));
          response = await PaymentService.GetPaymentDetailsAhlyMomken(searchParams.get('id'));
        }else if(method.toLocaleLowerCase() === "fawry"){
          console.log(searchParams.get('merchantRefNumber'));
          response = await PaymentService.GetPaymentDetailsFawry({
            merchantRefNumber: searchParams.get('merchantRefNumber'),
            type: searchParams.get('type'),
            statusCode: searchParams.get('statusCode'),
            statusDescription: (searchParams.get('statusDescription') || '').replace('+', ' '),
            basketPayment: searchParams.get('basketPayment')==='true'?true:false,
          });
        }else if(method.toLocaleLowerCase() === "noon"){
          const noonRef = searchParams.get('merchantReference') || searchParams.get('orderId') || searchParams.get('reference');
          response = await PaymentService.GetPaymentDetailsNoon(noonRef);
        }

        if (!response || !response.result) {
          setError(t('Callback.Error.NoResponse') || 'Could not retrieve payment details. Please contact support.');
          setLoading(false);
          return;
        }
        
        const result = response.result;
        const mappedPaymentDetails = {
          name: result.customerName || '',
          description: result.description || '',
          isPaid: result.isPaid || false,
          date: result.createdAt || new Date().toISOString(),
          amount: result.amount || 0,
          transactionId: result.paymentId || '',
          paymentMethod: method?.toUpperCase() || 'PayPal',
          currency: result.currency || '',
          customerEmail: result.customerEmail || '',
          customerMobile: result.customerMobile || ''
        };
        setPaymentDetails(mappedPaymentDetails);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching payment details:', error);
        setError(t('Callback.Error.FetchFailed') || 'An error occurred while loading your payment details. Your payment may have been processed successfully. Please check your email or contact support.');
        setLoading(false);
      }
    };

    fetchPaymentDetails();
  }, []);

  const handleCopy = async () => {
    if (paymentDetails?.transactionId) {
      await navigator.clipboard.writeText(paymentDetails.transactionId);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  const handlePrint = () => {
    // Extract data from the callback page or use paymentDetails
    const name = paymentDetails?.name || '';
    const description = paymentDetails?.description || '';
    const status = paymentDetails?.isPaid ? 'Completed' : '';
    const date = paymentDetails?.date ? new Date(paymentDetails.date).toLocaleString() : '';
    const amount = paymentDetails ? `${paymentDetails.amount.toFixed(2)} ${paymentDetails.currency}` : '';
    const email = paymentDetails?.customerEmail || '';
    const phone = paymentDetails?.customerMobile || '';
    const paymentMethod = paymentDetails?.paymentMethod || '';
    const transactionId = paymentDetails?.transactionId || '';
    
    // Language-specific content
    const isArabic = i18n.language === 'ar';
    
    const content = {
      ar: {
        // companyLogo: 'أبواب الخير',
        receiptTitle: 'إيصال الدفع',
        amountLabel: 'المبلغ المدفوع',
        nameLabel: 'الاسم:',
        descriptionLabel: 'الوصف:',
        dateLabel: 'التاريخ:',
        emailLabel: 'البريد الإلكتروني:',
        phoneLabel: 'رقم الهاتف:',
        paymentMethodLabel: 'طريقة الدفع',
        transactionIdLabel: 'رقم العملية',
        footerText: 'شكراً لك'
      },
      en: {
        // companyLogo: 'Abwab Al-Khair',
        receiptTitle: 'Payment Receipt',
        amountLabel: 'Amount Paid',
        nameLabel: 'Name:',
        descriptionLabel: 'Description:',
        dateLabel: 'Date:',
        emailLabel: 'Email:',
        phoneLabel: 'Phone:',
        paymentMethodLabel: 'Payment Method',
        transactionIdLabel: 'Transaction ID',
        footerText: 'Thank you'
      }
    };
    
    const currentContent = content[i18n.language] || content.en;
    
    // Create print window
    const printWindow = window.open('', '_blank');
    
    // Write the HTML content with embedded styles
    printWindow.document.write(`
      <!DOCTYPE html>
      <html lang="${i18n.language}">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>${t('Callback.Print.Title')}</title>
          <link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700&family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet">
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            
            body {
              font-family: ${isArabic ? "'Cairo', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" : "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"};
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              min-height: 100vh;
              padding: 20px;
              direction: ${isArabic ? 'rtl' : 'ltr'};
              line-height: 1.6;
            }
            
            .receipt-container {
              max-width: 400px;
              margin: 0 auto;
              background: white;
              border-radius: 20px;
              box-shadow: 0 20px 40px rgba(0,0,0,0.1);
              overflow: hidden;
              position: relative;
            }
            
            .receipt-header {
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              color: white;
              padding: 30px 20px;
              text-align: center;
              position: relative;
            }
            
            .receipt-header::before {
              content: '';
              position: absolute;
              top: -50%;
              left: -50%;
              width: 200%;
              height: 200%;
              background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
              animation: float 6s ease-in-out infinite;
            }
            
            @keyframes float {
              0%, 100% { transform: translateY(0px) rotate(0deg); }
              50% { transform: translateY(-20px) rotate(180deg); }
            }
            
            .company-logo {
              font-size: 24px;
              font-weight: 700;
              margin-bottom: 10px;
              text-shadow: 0 2px 4px rgba(0,0,0,0.3);
            }
            
            .receipt-title {
              font-size: 18px;
              font-weight: 400;
              opacity: 0.9;
            }
            
            .receipt-body {
              padding: 30px 20px;
            }
            
            .status-badge {
              display: inline-block;
              background: linear-gradient(135deg, #4CAF50, #45a049);
              color: white;
              padding: 8px 20px;
              border-radius: 25px;
              font-size: 14px;
              font-weight: 600;
              margin-bottom: 25px;
              box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
              text-align: center;
              width: 100%;
            }
            
            .amount-section {
              text-align: center;
              margin-bottom: 30px;
              padding: 20px;
              background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
              border-radius: 15px;
              border: 2px solid #e9ecef;
            }
            
            .amount-label {
              font-size: 14px;
              color: #6c757d;
              margin-bottom: 8px;
              font-weight: 400;
            }
            
            .amount-value {
              font-size: 32px;
              font-weight: 700;
              color: #2c3e50;
              text-shadow: 0 2px 4px rgba(0,0,0,0.1);
            }
            
            .info-grid {
              display: grid;
              gap: 15px;
              margin-bottom: 25px;
            }
            
            .info-item {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 12px 0;
              border-bottom: 1px solid #f1f3f4;
            }
            
            .info-item:last-child {
              border-bottom: none;
            }
            
            .info-label {
              font-size: 13px;
              color: #6c757d;
              font-weight: 500;
              flex: 1;
            }
            
            .info-value {
              font-size: 13px;
              color: #2c3e50;
              font-weight: 600;
              text-align: ${isArabic ? 'left' : 'right'};
              flex: 2;
            }
            
            .payment-method {
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              color: white;
              padding: 15px;
              border-radius: 12px;
              text-align: center;
              margin-bottom: 20px;
            }
            
            .payment-method-label {
              font-size: 12px;
              opacity: 0.8;
              margin-bottom: 5px;
            }
            
            .payment-method-value {
              font-size: 16px;
              font-weight: 600;
            }
            
            .transaction-id {
              background: #f8f9fa;
              padding: 15px;
              border-radius: 10px;
              text-align: center;
              border: 1px dashed #dee2e6;
            }
            
            .transaction-id-label {
              font-size: 11px;
              color: #6c757d;
              margin-bottom: 5px;
            }
            
            .transaction-id-value {
              font-size: 12px;
              color: #495057;
              font-family: 'Courier New', monospace;
              word-break: break-all;
            }
            
            .receipt-footer {
              background: #f8f9fa;
              padding: 20px;
              text-align: center;
              border-top: 1px solid #e9ecef;
            }
            
            .footer-text {
              font-size: 12px;
              color: #6c757d;
              line-height: 1.5;
            }
            
            .watermark {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-45deg);
              font-size: 80px;
              color: rgba(102, 126, 234, 0.03);
              font-weight: 900;
              pointer-events: none;
              z-index: 1;
            }
            
            @media print {
              body {
                background: white !important;
                padding: 0 !important;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:column;
              }
              
              .receipt-container {
                box-shadow: none !important;
                border: 1px solid #ddd !important;
                margin: 0 !important;
                
              }
              
              .watermark {
                display: none !important;
              }
              
              .receipt-header {
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
                -webkit-print-color-adjust: exact !important;
                color-adjust: exact !important;
              }
              
              .status-badge {
                background: linear-gradient(135deg, #4CAF50, #45a049) !important;
                -webkit-print-color-adjust: exact !important;
                color-adjust: exact !important;
              }
              
              .payment-method {
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
                -webkit-print-color-adjust: exact !important;
                color-adjust: exact !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="receipt-container">
            <div class="watermark">✓</div>
            
            <div class="receipt-header">
              <!-- <div class="company-logo">${currentContent.companyLogo}</div> -->
              <div class="receipt-title">${currentContent.receiptTitle}</div>
            </div>
            
            <div class="receipt-body">
              <div class="status-badge">
                ${status}
              </div>
              
              <div class="amount-section">
                <div class="amount-label">${currentContent.amountLabel}</div>
                <div class="amount-value">${amount}</div>
              </div>
              
              <div class="info-grid">
                <div class="info-item">
                  <div class="info-label">${currentContent.nameLabel}</div>
                  <div class="info-value">${name}</div>
                </div>
                
                <div class="info-item">
                  <div class="info-label">${currentContent.descriptionLabel}</div>
                  <div class="info-value">${description}</div>
                </div>
                
                <div class="info-item">
                  <div class="info-label">${currentContent.dateLabel}</div>
                  <div class="info-value">${date}</div>
                </div>
                
                <div class="info-item">
                  <div class="info-label">${currentContent.emailLabel}</div>
                  <div class="info-value">${email}</div>
                </div>
                
                <div class="info-item">
                  <div class="info-label">${currentContent.phoneLabel}</div>
                  <div class="info-value">${phone}</div>
                </div>
              </div>
              
              <div class="payment-method">
                <div class="payment-method-label">${currentContent.paymentMethodLabel}</div>
                <div class="payment-method-value">${paymentMethod}</div>
              </div>
              
              <div class="transaction-id">
                <div class="transaction-id-label">${currentContent.transactionIdLabel}</div>
                <div class="transaction-id-value">${transactionId}</div>
              </div>
            </div>
            
            <div class="receipt-footer">
              <div class="footer-text">
                ${currentContent.footerText}
              </div>
            </div>
          </div>
        </body>
      </html>
    `);
    
    // Wait for fonts to load before printing
    printWindow.document.close();
    
    // Wait for fonts and images to load
    setTimeout(() => {
    printWindow.focus();
    printWindow.print();
      setTimeout(() => {
    printWindow.close();
      }, 1000);
    }, 500);
  };

  if (loading) {
    return (
      <div className="callback-page callback-page--loading" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
        <div className="callback-page__loader"></div>
        <p>{t('Callback.Loading')}</p>
      </div>
    );
  }

  if (error || !paymentDetails) {
    return (
      <div className="callback-page callback-page--error" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
        <div className="callback-page__card">
          <h2 style={{ marginBottom: '16px', color: '#e74c3c' }}>{t('Callback.Error.Title') || 'Payment Status'}</h2>
          <p style={{ marginBottom: '16px', fontSize: '16px', lineHeight: '1.6' }}>
            {error || t('Callback.NoDetails')}
          </p>
          <CTAPrimaryButton
            icon={faArrowLeft}
            text={t('Callback.Buttons.Back')}
            onClick={() => navigate('/')}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="callback-page" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="callback-page__card">
        <h1 className="callback-page__title">{t('Callback.Title')}</h1>

        <div className="callback-page__details">
          <div className="callback-page__row">
            <span className="callback-page__label">{t('Callback.Labels.Name')}:</span>
            <span className="callback-page__value">{paymentDetails.name}</span>
          </div>

          <div className="callback-page__row">
            <span className="callback-page__label">{t('Callback.Labels.Description')}:</span>
            <span className="callback-page__value me-3 p-3">{paymentDetails.description}</span>
          </div>

          <div className="callback-page__row">
            <span className="callback-page__label">{t('Callback.Labels.Status')}:</span>
            <span className={`callback-page__status callback-page__status--${paymentDetails.isPaid ? 'paid' : 'unpaid'}`}>
              {paymentDetails.isPaid ? t('Callback.Status.Completed') : t('Callback.Status.Unpaid')}
            </span>
          </div>

          <div className="callback-page__row">
            <span className="callback-page__label">{t('Callback.Labels.Date')}:</span>
            <span className="callback-page__value">
              {new Date(paymentDetails.date).toLocaleString()}
            </span>
          </div>

          <div className="callback-page__row">
            <span className="callback-page__label">{t('Callback.Labels.Amount')}:</span>
            <span className="callback-page__value callback-page__amount">
              {paymentDetails.amount.toFixed(2)} {paymentDetails.currency}
            </span>
          </div>

          <div className="callback-page__row">
            <span className="callback-page__label">{t('Callback.Labels.Email')}:</span>
            <span className="callback-page__value">{paymentDetails.customerEmail}</span>
          </div>

          <div className="callback-page__row">
            <span className="callback-page__label">{t('Callback.Labels.Mobile')}:</span>
            <span className="callback-page__value">{paymentDetails.customerMobile}</span>
          </div>

          <div className="callback-page__row">
            <span className="callback-page__label">{t('Callback.Labels.PaymentMethod')}:</span>
            <div className="callback-page__payment-method">
              <span className="callback-page__payment-type">
                {paymentDetails.paymentMethod}
              </span>
            </div>
          </div>

          <div className="callback-page__row">
            <span className="callback-page__label">{t('Callback.Labels.TransactionId')}:</span>
            <div className="callback-page__transaction">
              <span className="callback-page__value">{paymentDetails.transactionId}</span>
              <button
                className={`callback-page__copy-btn ${copied ? 'callback-page__copy-btn--copied' : ''}`}
                onClick={handleCopy}
                title={t('Callback.Buttons.Copy')}
              >
                {copied ? <FontAwesomeIcon icon={faCheck} /> : <FontAwesomeIcon icon={faCopy} />}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="callback-page__buttons d-flex justify-content-between align-items-center">
        <CTAPrimaryButton
          className="me-3"
          icon={faArrowLeft}
          text={t('Callback.Buttons.Back')}
          onClick={handleBackToHome}
        />

        <CTASecondaryButton
          icon={faPrint}
          text={t('Callback.Buttons.Print')}
          onClick={handlePrint}
        />
      </div>
    </div>
  );
};

export default CallBack;
